module.exports = __webpack_public_path__ + "img/emoji_spritesheet_2.06aca5a6.png";